async function loadData(page) {
  fetch(page)
    .then(function (data) {
      return data.text();
    })
    .then(function (html) {
      var parser = new DOMParser();
      // Parse the text
      var doc = parser.parseFromString(html, 'text/html');
      var test = doc.querySelector('#MainContent');
      document.querySelector('#MainContent').innerHTML = test.innerHTML;
    });
}

addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.variant-selector a');
  buttons.forEach((item) => {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      loadData(item.href);
    });
  });
});
